/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["items", "nav", "options", "rtl", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import _isFunction from 'lodash/isFunction';
import T from 'prop-types';
import FocusDiv from '../FocusDiv/FocusDiv';
import { updatePrefix } from '../utils/utils';
import FocusHeroCarousel from './FocusHeroCarousel';
var heroDefaultOptions = {
  dots: true,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};
var FocusHeroBanner = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FocusHeroBanner, _React$PureComponent);
  var _super = _createSuper(FocusHeroBanner);
  function FocusHeroBanner() {
    var _this;
    _classCallCheck(this, FocusHeroBanner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      focusIndex: 0
    });
    _defineProperty(_assertThisInitialized(_this), "childOnBeforeChange", function (curPos, nextPos) {
      var options = _this.props.options;

      // Update focusIndex for the forwardFocus. When re-focus from other component we can get up
      // to date focus for HeroBanner from autoplay
      _this.setState({
        focusIndex: nextPos
      });
      if (_isFunction(options.beforeChange)) {
        options.beforeChange(curPos, nextPos);
      }
    });
    return _this;
  }
  _createClass(FocusHeroBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        items = _this$props.items,
        nav = _this$props.nav,
        options = _this$props.options,
        rtl = _this$props.rtl,
        style = _this$props.style,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var prefix = updatePrefix(this);
      var navOverride = _objectSpread({
        forwardFocus: "".concat(prefix).concat(this.state.focusIndex)
      }, nav);
      var overloadedHeroCarouselOptions = _objectSpread(_objectSpread(_objectSpread({}, heroDefaultOptions), options), {}, {
        beforeChange: this.childOnBeforeChange
      });
      return /*#__PURE__*/React.createElement(FocusDiv, {
        nav: navOverride,
        rtl: rtl,
        style: style
      }, /*#__PURE__*/React.createElement(FocusHeroCarousel, _extends({
        items: items,
        options: overloadedHeroCarouselOptions
      }, otherProps, {
        nav: nav,
        prefix: prefix,
        rtl: rtl
      })));
    }
  }]);
  return FocusHeroBanner;
}(React.PureComponent);
_defineProperty(FocusHeroBanner, "propTypes", {
  /** Objects containing each `displayObject` data.   */
  items: T.array.isRequired,
  /** VDKWEB navigation object.        */
  nav: T.object,
  /** Global property object for Carousel/Slick props   */
  options: T.shape({
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    arrows: T.bool,
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    autoplay: T.bool,
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    autoplaySpeed: T.number,
    /** Function to execute before any change done to the items */
    beforeChange: T.func,
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    dots: T.bool,
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    infinite: T.bool,
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    slidesToScroll: T.number,
    /** As per [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/main/packages/vdkweb-react-slick/) */
    slidesToShow: T.number
  }),
  /** String prefix for each item of the carousel. `Date.now().toString(36)` will be used as default if not provided */
  prefix: T.string,
  /** True whether the Hero must show elements from right to left   */
  rtl: T.bool,
  /** Objects containing each `displayObject` data.   */
  style: T.object
});
_defineProperty(FocusHeroBanner, "defaultProps", {
  nav: {},
  options: heroDefaultOptions,
  prefix: '',
  rtl: false,
  style: {}
});
export default FocusHeroBanner;